module.exports = __webpack_public_path__ + "static/media/dublin-bus.ac3fc504.jpg";